import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { authApi } from './auth'
import { queryKeys } from './query-keys'
import type { UpdateProfileRequest } from './types'
import { useAuth } from '@/lib/auth/auth-context'

export function useProfile() {
  return useQuery({
    queryKey: queryKeys.auth.profile(),
    queryFn: () => authApi.getProfile(),
  })
}

export function useUpdateProfile() {
  const queryClient = useQueryClient()
  const { refreshUser } = useAuth()

  return useMutation({
    mutationFn: (data: UpdateProfileRequest) => authApi.updateProfile(data),
    onSuccess: async (updated) => {
      queryClient.setQueryData(queryKeys.auth.profile(), updated)
      await refreshUser()
    },
  })
}
